export const currenciesMap = new Map([
  [
    'GBP',
    {
      currency: 'GBP',
      currency_sign: '£',
      currency_sign_position: 'before',
      currency_decimal_number: 2,
      currency_thousands_separator: ',',
      currency_decimal_separator: '.',
    },
  ],
  [
    'EUR',
    {
      currency: 'EUR',
      currency_sign: '€',
      currency_sign_position: 'after',
      currency_decimal_number: 2,
      currency_thousands_separator: ',',
      currency_decimal_separator: '.',
    },
  ],
  [
    'USD',
    {
      currency: 'USD',
      currency_sign: '$',
      currency_sign_position: 'before',
      currency_decimal_number: 2,
      currency_thousands_separator: ',',
      currency_decimal_separator: '.',
    },
  ],
  [
    'ALL',
    {
      currency: 'ALL',
      currency_sign: 'L',
      currency_sign_position: 'before',
      currency_decimal_number: 2,
      currency_thousands_separator: '.',
      currency_decimal_separator: ',',
    },
  ],
  [
    'ARS',
    {
      currency: 'ARS',
      currency_sign: '$',
      currency_sign_position: 'before',
      currency_decimal_number: 2,
      currency_thousands_separator: ',',
      currency_decimal_separator: '.',
    },
  ],
  [
    'AUD',
    {
      currency: 'AUD',
      currency_sign: '$',
      currency_sign_position: 'before',
      currency_decimal_number: 2,
      currency_thousands_separator: ',',
      currency_decimal_separator: '.',
    },
  ],
  [
    'BSD',
    {
      currency: 'BSD',
      currency_sign: '$',
      currency_sign_position: 'before',
      currency_decimal_number: 2,
      currency_thousands_separator: ',',
      currency_decimal_separator: '.',
    },
  ],
  [
    'BHD',
    {
      currency: 'BHD',
      currency_sign: '.د.ب',
      currency_sign_position: 'before',
      currency_decimal_number: 3,
      currency_thousands_separator: ',',
      currency_decimal_separator: '.',
    },
  ],
  [
    'BBD',
    {
      currency: 'BBD',
      currency_sign: '$',
      currency_sign_position: 'before',
      currency_decimal_number: 2,
      currency_thousands_separator: ',',
      currency_decimal_separator: '.',
    },
  ],
  [
    'BRL',
    {
      currency: 'BRL',
      currency_sign: 'R$',
      currency_sign_position: 'before',
      currency_decimal_number: 2,
      currency_thousands_separator: '.',
      currency_decimal_separator: ',',
    },
  ],
  [
    'BGN',
    {
      currency: 'BGN',
      currency_sign: 'лв',
      currency_sign_position: 'after',
      currency_decimal_number: 2,
      currency_thousands_separator: ',',
      currency_decimal_separator: '.',
    },
  ],
  [
    'CAD',
    {
      currency: 'CAD',
      currency_sign: '$',
      currency_sign_position: 'before',
      currency_decimal_number: 2,
      currency_thousands_separator: ',',
      currency_decimal_separator: '.',
    },
  ],
  [
    'CNY',
    {
      currency: 'CNY',
      currency_sign: '¥',
      currency_sign_position: 'before',
      currency_decimal_number: 2,
      currency_thousands_separator: ',',
      currency_decimal_separator: '.',
    },
  ],
  [
    'CRC',
    {
      currency: 'CRC',
      currency_sign: '₡',
      currency_sign_position: 'before',
      currency_decimal_number: 2,
      currency_thousands_separator: ',',
      currency_decimal_separator: '.',
    },
  ],
  [
    'HRK',
    {
      currency: 'HRK',
      currency_sign: 'kn',
      currency_sign_position: 'after',
      currency_decimal_number: 2,
      currency_thousands_separator: ',',
      currency_decimal_separator: '.',
    },
  ],
  [
    'CUP',
    {
      currency: 'CUP',
      currency_sign: '$',
      currency_sign_position: 'before',
      currency_decimal_number: 2,
      currency_thousands_separator: ',',
      currency_decimal_separator: '.',
    },
  ],
  [
    'CZK',
    {
      currency: 'CZK',
      currency_sign: 'Kč',
      currency_sign_position: 'after',
      currency_decimal_number: 2,
      currency_thousands_separator: ',',
      currency_decimal_separator: '.',
    },
  ],
  [
    'DKK',
    {
      currency: 'DKK',
      currency_sign: 'kr',
      currency_sign_position: 'before',
      currency_decimal_number: 2,
      currency_thousands_separator: '.',
      currency_decimal_separator: ',',
    },
  ],
  [
    'DOP',
    {
      currency: 'DOP',
      currency_sign: 'RD$',
      currency_sign_position: 'before',
      currency_decimal_number: 2,
      currency_thousands_separator: ',',
      currency_decimal_separator: '.',
    },
  ],
  [
    'EGP',
    {
      currency: 'EGP',
      currency_sign: '£',
      currency_sign_position: 'before',
      currency_decimal_number: 2,
      currency_thousands_separator: ',',
      currency_decimal_separator: '.',
    },
  ],
  [
    'FJD',
    {
      currency: 'FJD',
      currency_sign: '$',
      currency_sign_position: 'before',
      currency_decimal_number: 2,
      currency_thousands_separator: ',',
      currency_decimal_separator: '.',
    },
  ],
  [
    'ISK',
    {
      currency: 'ISK',
      currency_sign: 'kr',
      currency_sign_position: 'after',
      currency_decimal_number: 0,
      currency_thousands_separator: '.',
      currency_decimal_separator: ',',
    },
  ],
  [
    'INR',
    {
      currency: 'INR',
      currency_sign: '₹',
      currency_sign_position: 'before',
      currency_decimal_number: 2,
      currency_thousands_separator: ',',
      currency_decimal_separator: '.',
    },
  ],
  [
    'IDR',
    {
      currency: 'IDR',
      currency_sign: 'Rp',
      currency_sign_position: 'before',
      currency_decimal_number: 0,
      currency_thousands_separator: ',',
      currency_decimal_separator: '.',
    },
  ],
  [
    'ILS',
    {
      currency: 'ILS',
      currency_sign: '₪',
      currency_sign_position: 'before',
      currency_decimal_number: 2,
      currency_thousands_separator: ',',
      currency_decimal_separator: '.',
    },
  ],
  [
    'JMD',
    {
      currency: 'JMD',
      currency_sign: '$',
      currency_sign_position: 'before',
      currency_decimal_number: 2,
      currency_thousands_separator: ',',
      currency_decimal_separator: '.',
    },
  ],
  [
    'JPY',
    {
      currency: 'JPY',
      currency_sign: '¥',
      currency_sign_position: 'before',
      currency_decimal_number: 0,
      currency_thousands_separator: ',',
      currency_decimal_separator: '.',
    },
  ],
  [
    'JOD',
    {
      currency: 'JOD',
      currency_sign: 'د.ا',
      currency_sign_position: 'before',
      currency_decimal_number: 3,
      currency_thousands_separator: ',',
      currency_decimal_separator: '.',
    },
  ],
  [
    'KWD',
    {
      currency: 'KWD',
      currency_sign: 'د.ك',
      currency_sign_position: 'before',
      currency_decimal_number: 3,
      currency_thousands_separator: ',',
      currency_decimal_separator: '.',
    },
  ],
  [
    'MYR',
    {
      currency: 'MYR',
      currency_sign: 'RM',
      currency_sign_position: 'before',
      currency_decimal_number: 2,
      currency_thousands_separator: ',',
      currency_decimal_separator: '.',
    },
  ],
  [
    'MVR',
    {
      currency: 'MVR',
      currency_sign: 'ރ.',
      currency_sign_position: 'before',
      currency_decimal_number: 2,
      currency_thousands_separator: ',',
      currency_decimal_separator: '.',
    },
  ],
  [
    'MXN',
    {
      currency: 'MXN',
      currency_sign: '$',
      currency_sign_position: 'before',
      currency_decimal_number: 2,
      currency_thousands_separator: ',',
      currency_decimal_separator: '.',
    },
  ],
  [
    'NZD',
    {
      currency: 'NZD',
      currency_sign: '$',
      currency_sign_position: 'before',
      currency_decimal_number: 2,
      currency_thousands_separator: ',',
      currency_decimal_separator: '.',
    },
  ],
  [
    'NOK',
    {
      currency: 'NOK',
      currency_sign: 'kr',
      currency_sign_position: 'after',
      currency_decimal_number: 2,
      currency_thousands_separator: ',',
      currency_decimal_separator: '.',
    },
  ],
  [
    'OMR',
    {
      currency: 'OMR',
      currency_sign: 'ر.ع.',
      currency_sign_position: 'before',
      currency_decimal_number: 3,
      currency_thousands_separator: ',',
      currency_decimal_separator: '.',
    },
  ],
  [
    'PLN',
    {
      currency: 'PLN',
      currency_sign: 'zł',
      currency_sign_position: 'after',
      currency_decimal_number: 2,
      currency_thousands_separator: ' ',
      currency_decimal_separator: ',',
    },
  ],
  [
    'QAR',
    {
      currency: 'QAR',
      currency_sign: 'ر.ق',
      currency_sign_position: 'before',
      currency_decimal_number: 2,
      currency_thousands_separator: ',',
      currency_decimal_separator: '.',
    },
  ],
  [
    'RON',
    {
      currency: 'RON',
      currency_sign: 'lei',
      currency_sign_position: 'after',
      currency_decimal_number: 2,
      currency_thousands_separator: '.',
      currency_decimal_separator: ',',
    },
  ],
  [
    'RUB',
    {
      currency: 'RUB',
      currency_sign: '₽',
      currency_sign_position: 'after',
      currency_decimal_number: 2,
      currency_thousands_separator: ' ',
      currency_decimal_separator: ',',
    },
  ],
  [
    'SAR',
    {
      currency: 'SAR',
      currency_sign: 'ر.س',
      currency_sign_position: 'before',
      currency_decimal_number: 2,
      currency_thousands_separator: ',',
      currency_decimal_separator: '.',
    },
  ],
  [
    'SGD',
    {
      currency: 'SGD',
      currency_sign: '$',
      currency_sign_position: 'before',
      currency_decimal_number: 2,
      currency_thousands_separator: ',',
      currency_decimal_separator: '.',
    },
  ],
  [
    'ZAR',
    {
      currency: 'ZAR',
      currency_sign: 'R',
      currency_sign_position: 'before',
      currency_decimal_number: 2,
      currency_thousands_separator: ',',
      currency_decimal_separator: '.',
    },
  ],
  [
    'KRW',
    {
      currency: 'KRW',
      currency_sign: '₩',
      currency_sign_position: 'before',
      currency_decimal_number: 0,
      currency_thousands_separator: ',',
      currency_decimal_separator: '.',
    },
  ],
  [
    'SEK',
    {
      currency: 'SEK',
      currency_sign: 'kr',
      currency_sign_position: 'before',
      currency_decimal_number: 2,
      currency_thousands_separator: ' ',
      currency_decimal_separator: ',',
    },
  ],
  [
    'CHF',
    {
      currency: 'CHF',
      currency_sign: 'CHF',
      currency_sign_position: 'before',
      currency_decimal_number: 2,
      currency_thousands_separator: "'",
      currency_decimal_separator: '.',
    },
  ],
  [
    'TWD',
    {
      currency: 'TWD',
      currency_sign: 'NT$',
      currency_sign_position: 'before',
      currency_decimal_number: 2,
      currency_thousands_separator: ',',
      currency_decimal_separator: '.',
    },
  ],
  [
    'THB',
    {
      currency: 'THB',
      currency_sign: '฿',
      currency_sign_position: 'before',
      currency_decimal_number: 2,
      currency_thousands_separator: ',',
      currency_decimal_separator: '.',
    },
  ],
  [
    'TRY',
    {
      currency: 'TRY',
      currency_sign: '₺',
      currency_sign_position: 'before',
      currency_decimal_number: 2,
      currency_thousands_separator: ',',
      currency_decimal_separator: '.',
    },
  ],
  [
    'UAH',
    {
      currency: 'UAH',
      currency_sign: '₴',
      currency_sign_position: 'before',
      currency_decimal_number: 2,
      currency_thousands_separator: ' ',
      currency_decimal_separator: ',',
    },
  ],
  [
    'AED',
    {
      currency: 'AED',
      currency_sign: 'د.إ',
      currency_sign_position: 'before',
      currency_decimal_number: 2,
      currency_thousands_separator: ',',
      currency_decimal_separator: '.',
    },
  ],
  [
    'VND',
    {
      currency: 'VND',
      currency_sign: '₫',
      currency_sign_position: 'before',
      currency_decimal_number: 0,
      currency_thousands_separator: ',',
      currency_decimal_separator: '.',
    },
  ],
])
